import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Copy, Icon, IconWrapper, Optional, useThemeContext } from '@honda-canada/design-system-react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import themeStyles from './ProvinceBanner.styles';
import useAutoReload from './hooks/useAutoReload';
import { selectShouldRenderProvinceBanner, setShouldRenderProvinceBanner } from '../../core/reducers/ui';
import { useAppSelector } from '../../core/utils';
import { useProvinces, useUserOrDefaultProvince } from '../../utils/sitecoreContext';
const ProvinceBannerContainer = themeStyles.apply(Box, 'ProvinceBannerContainer');
const ProvinceBannerText = themeStyles.apply(Copy, 'ProvinceBannerText');
const CloseIconContainer = themeStyles.apply(Box, 'CloseIconContainer');
const MapMarkerContainer = themeStyles.apply(Box, 'MapMarkerContainer');
const MapMarkerIconWrapper = themeStyles.apply(IconWrapper, 'MapMarkerIconWrapper');
const ProvinceBanner = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { colors } = useThemeContext();
    const userLocation = useUserOrDefaultProvince();
    const sitecoreProvinces = useProvinces();
    const province = sitecoreProvinces === null || sitecoreProvinces === void 0 ? void 0 : sitecoreProvinces.find(_province => (_province === null || _province === void 0 ? void 0 : _province.name) === userLocation);
    const shouldRenderBanner = useAppSelector(selectShouldRenderProvinceBanner);
    useAutoReload(userLocation);
    const handleCloseIconClick = () => {
        dispatch(setShouldRenderProvinceBanner(!shouldRenderBanner));
    };
    return (_jsx(Optional, { when: shouldRenderBanner, children: _jsxs(ProvinceBannerContainer, { "data-testid": "cy-special-offers-province-banner", children: [_jsx(MapMarkerContainer, { children: _jsx(MapMarkerIconWrapper, { "data-testid": "cy-special-offers-province-banner-location-icon", children: _jsx(Icon, { name: "mapMarker", color: "white", circleColor: colors.blue }) }) }), _jsx(ProvinceBannerText, { size: "regular", children: t('Pages.SpecialOffers.defaultProvinceBannerText', {
                        provinceName: province === null || province === void 0 ? void 0 : province.displayName,
                    }) }), _jsx(CloseIconContainer, { children: _jsx(IconWrapper, { size: "iconWrapper.xss", onClick: handleCloseIconClick, "data-testid": "cy-special-offers-province-banner-cross-icon", children: _jsx(Icon, { name: "close", color: "white" }) }) })] }) }));
};
export default ProvinceBanner;
